// Set up the URL constants and default parameteres to break the URL endpoint for the API request
const DEFAULT_QUERY = 'react';
const DEFAULT_HPP = '100';
const PATH_BASE = 'https://hn.algolia.com/api/v1';
const PATH_SEARCH = '/search';
const PARAM_SEARCH = 'query=';
const PARAM_PAGE = 'page=';
const PARAM_HPP = 'hitsPerPage=';

export { 
    DEFAULT_QUERY, 
    DEFAULT_HPP, 
    PATH_BASE, 
    PATH_SEARCH, 
    PARAM_SEARCH, 
    PARAM_PAGE, 
    PARAM_HPP, 
};